import type { MiTorneo } from '../datos/index.js'
import { Bandera } from './Bandera.js'

/**
 * Su pareja, en un torneo de esa modalidad.
 *
 * Es la tarjeta que contesta la pregunta que en Parejas viene antes que «¿en
 * qué mesa voy?»: con quién juego y con qué número me llaman. El número es el
 * de la pareja y no el de la ficha, porque en esta modalidad es el único que
 * existe para el salón: el que se grita, el que va en la hoja de mesa y el que
 * sale en la proyección.
 *
 * Existe desde la inscripción, no desde el inicio: la pareja es nómina, y el
 * que se anotó de a dos quiere verla el día antes. Por eso la nota de abajo
 * cambia con el momento: antes de arrancar dice si falta el check-in, y con el
 * torneo andando recuerda el número, que es lo que se busca en la proyección.
 *
 * Vive suelta y no dentro de una pantalla por lo mismo que `MiPosicion`: la
 * usan la de hoy y el resumen del torneo, y son la misma pregunta.
 */
export function MiPareja({ torneo }: { torneo: MiTorneo }) {
  const pareja = torneo.pareja
  if (!pareja) return null

  const antes = torneo.estado === 'inscripcion' || torneo.estado === 'borrador'
  const coja = pareja.integrantes.length < 2

  return (
    <div className="mi-pareja">
      <div className="mi-pareja-cabecera">
        <span className="mi-pareja-titulo">Tu pareja</span>
        <span className="mi-pareja-numero">
          Nº <b>{pareja.numero}</b>
        </span>
      </div>

      <ul className="mi-pareja-integrantes">
        {pareja.integrantes.map((i) => (
          <li key={`${i.nombre}-${i.esMio ? 'yo' : 'otro'}`} className={`silla ${i.esMio ? 'mia' : ''}`}>
            <Bandera codigo={i.pais} />
            <span className="silla-nombre">{i.nombre}</span>
            {i.esMio && <span className="silla-tu">tú</span>}
          </li>
        ))}
      </ul>

      <p className="mi-pareja-nota tenue">
        {coja
          ? 'Tu pareja quedó con un solo integrante. Avisa a la organización antes de que arranque.'
          : antes
            ? pareja.confirmada
              ? 'Check-in hecho: entran al sorteo de la primera ronda.'
              : 'Falta el check-in. Se hace al llegar, con los dos: recién ahí entran al sorteo.'
            : `En el salón y en la proyección se los llama por el número ${pareja.numero}.`}
      </p>
    </div>
  )
}
